import { useBottomPanel } from '@ubnt/link-core-ui/components/BottomPanel/context/BottomPanelContext';

import OutdoorSwitch from 'modules/bottomPanel/containers/OutdoorSwitch';
import WifiStandardIcon from 'modules/bottomPanel/containers/WifiStandardIcon';
import MountSwitch from 'modules/bottomPanel/containers/MountSwitch';
import ClientDevicePanel, { ClientDevicePanelProps } from '../components/compositions/ClientDevicePanel';
import AddClientButton from './AddClientButton';
import ChangeAntennaButton from './ChangeAntennaButton';
import DevicePickerDropdown from './DevicePickerDropdown';
import DevicePickerImage from './DevicePickerImage';
import InfoIcon from './InfoIcon';

const ClientDevicePanelContainer = (props: Partial<ClientDevicePanelProps>) => {
  const { rightId } = useBottomPanel();

  if (!rightId) {
    return null;
  }

  return (
    <ClientDevicePanel
      id={rightId}
      AddClientButton={AddClientButton}
      ChangeAntennaButton={ChangeAntennaButton}
      DevicePickerDropdown={DevicePickerDropdown}
      DevicePickerImage={DevicePickerImage}
      InfoIcon={InfoIcon}
      WifiStandardIcon={WifiStandardIcon}
      OutdoorSwitch={OutdoorSwitch}
      MountSwitch={MountSwitch}
      {...props}
    />
  );
};

export default ClientDevicePanelContainer;
